import { Sub } from "@superwall-me/schema"
import {
  visibilityNoneToDisplayNoneMigrationScript,
  productDrawerSubstitutionMigrationScript,
  footerSubstitutionsMigrationScript,
  productsSwElementHasMigrationScript,
  createDrawerAndProductsComponents,
} from "app/paywalls/helpers/templateJsonSchemaMigrations/helpers/productDrawerSubstitutionMigrationScript"
import { TElement } from "app/schema/paywallTemplate/element/element"
import { TMarqueeElement } from "app/schema/paywallTemplate/element/elements/Marquee"
import { PaywallTemplateV11 } from "app/schema/paywallTemplate/paywallTemplate"
import { z } from "zod"

export const onAddVideoSubstitution = (
  id: string,
  onChangeSubstitutions: Function,
  substitutions: Sub[] | []
) => {
  const sub = {
    key: `Video ${id.toLowerCase()}`,
    value: "",
    skipInnerHTML: true,
    tagName: "div",
    subType: "video",
    properties: [
      {
        prefix: "default",
        property: {
          type: "video",
          coverURL: "",
          videoURLs: [
            {
              url: "https://static.superwallassets.com/pDjKamgQaSVxcdwG4M9VS",
            },
          ],
        },
      },
    ],
  }
  onChangeSubstitutions([...substitutions, sub])
}

export const onAddMarqueeSubstitution = (
  marqueeElement: TMarqueeElement,
  onChangeSubstitutions: Function,
  substitutions: Sub[] | []
) => {
  const subs = [
    {
      key: `Marquee ${marqueeElement.id.toLowerCase()}`,
      value: "",
      skipInnerHTML: true,
      tagName: "div",
      subType: "img",
      properties: [
        {
          prefix: "default",
          property: { type: "src", src: "", srcSet: [""] },
        },
      ],
    },
    ...(marqueeElement.children || []).map((child) => ({
      key: `Marquee Image ${child.id.toLowerCase()}`,
      value: "",
      skipInnerHTML: true,
      tagName: "img",
      subType: "img",
      properties: [
        {
          prefix: "default",
          property: {
            type: "src",
            src: "https://static.superwallassets.com/IPdycLolb5lXKpuolIqzA",
            srcSet: [""],
          },
        },
      ],
    })),
  ]

  onChangeSubstitutions([...substitutions, ...subs])
}

export const onAddImageSubstitution = (
  id: string,
  onChangeSubstitutions: Function,
  substitutions: Sub[] | []
) => {
  const sub = {
    key: `ImageBase ${id.toLowerCase()}`,
    value: "",
    skipInnerHTML: true,
    tagName: "img",
    subType: "img",
    properties: [
      {
        prefix: "default",
        property: {
          type: "src",
          src: "https://static.superwallassets.com/qfOQD4mBY0vmxhkxJ9ckB",
          srcSet: [""],
        },
      },
      {
        prefix: "default",
        property: {
          type: "styles",
          styles: [
            { property: "width", value: "100%" },
            { property: "height", value: "auto" },
          ],
        },
      },
    ],
    initialStyles: { width: "100%", height: "auto" },
  }
  onChangeSubstitutions([...substitutions, sub])
}

export const onAddLegacyImageSubstitutions = (
  id: string,
  onChangeSubstitutions: Function,
  substitutions: Sub[] | []
) => {
  const subs = [
    {
      key: `Image Wrapper ${id.toLowerCase()}`,
      value: "",
      skipInnerHTML: true,
      tagName: "div",
      subType: "img",
      properties: [
        {
          prefix: "default",
          property: {
            type: "src",
            src: "https://static.superwallassets.com/qfOQD4mBY0vmxhkxJ9ckB",
            srcSet: [""],
          },
        },
      ],
    },
    {
      key: `Image Wrapper ${id.toLowerCase()} > Image`,
      value: "",
      skipInnerHTML: true,
      tagName: "img",
      subType: "img",
      properties: [
        {
          prefix: "default",
          property: {
            type: "src",
            src: "https://static.superwallassets.com/qfOQD4mBY0vmxhkxJ9ckB",
            srcSet: [""],
          },
        },
      ],
    },
  ]
  onChangeSubstitutions([...substitutions, ...subs])
}

export const updateNecessarySubstitutions = (
  element: TElement,
  substitutions: Sub[],
  onChangeSubstitutions: Function
) => {
  if (element.name === "video") {
    onAddVideoSubstitution(element.id, onChangeSubstitutions, substitutions)
  } else if (element.name === "marquee") {
    onAddMarqueeSubstitution(element as TMarqueeElement, onChangeSubstitutions, substitutions)
  } else if (element.name === "image") {
    onAddLegacyImageSubstitutions(element.id, onChangeSubstitutions, substitutions)
  } else if (element.name === "imageBase") {
    onAddImageSubstitution(element.id, onChangeSubstitutions, substitutions)
  }
}

// TODO: Delete after drawer migration
export const manualDrawerMigrationScript = (
  templateJson: z.infer<typeof PaywallTemplateV11>,
  substitutions: Sub[]
): {
  templateJson: z.infer<typeof PaywallTemplateV11>
  substitutions: Sub[]
} => {
  const migratedSubs = visibilityNoneToDisplayNoneMigrationScript(
    productDrawerSubstitutionMigrationScript(
      footerSubstitutionsMigrationScript(substitutions, templateJson?.pageSettings || {}),
      templateJson?.pageSettings || {}
    )
  )
  const isUsingNewDrawer = templateJson?.pageSettings?.hideFixedPurchaseDrawer === "true"
  return {
    templateJson: {
      version: 11,
      pageSettings: {
        ...templateJson.pageSettings,
        customCSS: productsSwElementHasMigrationScript(templateJson?.pageSettings?.customCSS || ""),
        hideFixedPurchaseDrawer: "true",
      },
      backgroundContent: templateJson.backgroundContent || [],
      mainContent: isUsingNewDrawer
        ? templateJson.mainContent || []
        : [
            ...(templateJson.mainContent || []),
            ...createDrawerAndProductsComponents(
              templateJson.pageSettings || {},
              templateJson.cardContent
            ),
          ],
      cardContent: templateJson.cardContent || [],
    },
    substitutions: migratedSubs,
  }
}
